import { version as packageJsonVersion } from '../package.json';

const commit = import.meta.env.VITE_GIT_SHA;

const version = commit ?? packageJsonVersion;

export default version;
